package dev.kotlinfest._2026.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initCodeOfConductEnPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("CodeOfConductEn.md", FrontMatterElement.Builder { addScalar("title", "Code of Conduct"); addScalar("description", "Kotlin Fest is a conference tailored for developers. We aim to provide a safe, welcoming environment every participant. …"); }))
}

@Page("/code-of-conduct-en")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun CodeOfConductEnPage() {
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("/code-of-conduct") {
            org.jetbrains.compose.web.dom.Text("日本語")
        }
        org.jetbrains.compose.web.dom.Text(" / ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("English")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Kotlin Fest is a conference tailored for developers. We aim to provide a safe, welcoming environment every participant.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("All participants at Kotlin Fest are required to agree with the following Code of Conduct. Organizers will enforce this code at the conference, party and meetup-related social events. We expect cooperation from every participant (attendees, speakers, sponsors, hosts, staff members and organizers) to ensure a safe space for everybody.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our conference is dedicated to providing a safe environment for everyone, regardless of gender, gender identity and expression, age, sexual orientation, disability, physical appearance, body size, race, ethnicity, religion (or lack thereof), technology choices, deliberate intimidation, stalking, following, harassing photography or recording, sustained disruption of talks or other events, inappropriate physical contact, and unwelcome sexual attention. We do not tolerate harassment of participants in any shape or form. Sponsors, speakers and hosts are also subject to the anti-harassment policy. Sexual language and imagery are not appropriate at any talks, workshops, parties, X(Twitter) and other online media.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Participants asked to stop any harassing behavior are expected to comply immediately. Participants violating these rules may be removed from the conference and/or blocked from future events, at the discretion of the organizers, hosts, or sponsors.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you are being harassed, notice that someone else is being harassed, or have any other concerns, please contact one of our staff members immediately. We will be happy to help participants contact building security or police, or otherwise assist those experiencing harassment to feel safe for the duration of the conference.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This work is based on ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://nyc.droidcon.com/code-of-conduct/") {
            org.jetbrains.compose.web.dom.Text("Droidcon NYC Code of Conduct")
        }
        org.jetbrains.compose.web.dom.Text(" and ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://portal.droidkaigi.jp/en/about/code-of-conduct") {
            org.jetbrains.compose.web.dom.Text("DroidKaigi Code of Conduct")
        }
        org.jetbrains.compose.web.dom.Text(" which are licensed under CC-BY-3.0.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This work is licensed under a ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://creativecommons.org/licenses/by/3.0/deed.en_US") {
            org.jetbrains.compose.web.dom.Text("Creative Commons Attribution 3.0 Unported License")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Original source and credit: ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://2012.jsconf.us/#/about") {
            org.jetbrains.compose.web.dom.Text("http://2012.jsconf.us/#/about")
        }
        org.jetbrains.compose.web.dom.Text(" & ")
        com.varabyte.kobweb.silk.components.navigation.Link("http://geekfeminism.wikia.com/wiki/Conference_anti-harassment/Policy") {
            org.jetbrains.compose.web.dom.Text("The Ada Initiative")
        }
    }
}
